import { z } from 'zod';
import { requiredString } from '..';
import { FINANCIAL_PRODUCT } from '../constants';
import { applicantMetadata, generateSchema } from '../shared';
import { ApplicationStep } from '../types';
import { baseApplicationStep } from './baseApplication';
import { termsAndConditionsSchema } from './createApplication';

const defaultJointOtherApplicantPropertiesSchema = {
  applicant: z.object({}),
};

const jointOtherApplicantProperties = {
  applicant: z.object({
    unsolicitedSaleOptions: requiredString(),
    //TODO: make this mandatory later
    estimatedInstallationPeriod: z.string().optional(),
    ownProperty: z.boolean().optional(),
  }),
};

const otherJointApplicantPropertiesCustomSchemas = {
  [FINANCIAL_PRODUCT.ACT_SLIP]: jointOtherApplicantProperties,
  [FINANCIAL_PRODUCT.TAS_ESLS]: jointOtherApplicantProperties,
  [FINANCIAL_PRODUCT.ACT_SHS]: jointOtherApplicantProperties,
  [FINANCIAL_PRODUCT.BRIGHTE_PAY]: {
    applicant: z.object({
      unsolicitedSaleOptions: z.string().optional(),
      //TODO: make this mandatory later
      estimatedInstallationPeriod: z.string().optional(),
      ownProperty: z.boolean().optional(),
    }),
  },
};

export const otherJointApplicantPropertiesSchema = generateSchema<
  typeof otherJointApplicantPropertiesCustomSchemas,
  typeof defaultJointOtherApplicantPropertiesSchema
>({
  customSchemas: otherJointApplicantPropertiesCustomSchemas,
  defaultSchema: defaultJointOtherApplicantPropertiesSchema,
});

export const jointEligibilitySchema = baseApplicationStep.and(
  z
    .object({
      step: z.literal(ApplicationStep.JointEligibility),
      applicant: applicantMetadata.pick({ type: true, secureCode: true }),
    })
    .and(termsAndConditionsSchema)
    .and(otherJointApplicantPropertiesSchema),
);
